import { Component, OnInit } from '@angular/core';
import { Message, MessageTypes } from '../message';
import { Router } from '@angular/router';
import { MenuService } from '../menu/menu.service';

@Component({
  selector: 'app-birthdays',
  templateUrl: './birthdays.component.html',
  styleUrls: ['./birthdays.component.css']
})
export class BirthdaysComponent implements OnInit {
  public message: Message;
  constructor(protected router: Router, protected menuService: MenuService) {
    this.message = {text: '', type: MessageTypes.None};
  }

  ngOnInit() {
  }

  public showMessage(text: string, type: MessageTypes){
    this.message = {text: text, type: type};
  }

  public birthdayAdded() {
    // console.log('this should navigate to birthdays list');
    this.router.navigate(['/birthdays/list']);
  }
}



// WEBPACK FOOTER //
// ./src/app/birthdays/birthdays.component.ts